var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function(n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
__name(_extends, "_extends");
import React from "react";
import { FormItemRenderer } from "./Item";
import { FormRowSection } from "../sections/row/Row";
var _renderItem = /* @__PURE__ */ __name(function renderItem(_ref) {
  var initialValues = _ref.initialValues, form = _ref.form, intl = _ref.intl, layout = _ref.layout, customData = _ref.customData;
  return (
    // eslint-disable-next-line react/function-component-definition
    function(field, key) {
      if (Array.isArray(field)) {
        return /* @__PURE__ */ React.createElement(FormRowSection, {
          key: field.name || key
        }, field.map(_renderItem({
          initialValues,
          form,
          intl,
          layout,
          customData
        })));
      }
      return /* @__PURE__ */ React.createElement(FormItemRenderer, _extends({
        key: field.name || key
      }, field, {
        layout,
        form,
        intl,
        initialValue: initialValues && field && initialValues[field.name],
        customData
      }));
    }
  );
}, "renderItem");
function FormItemsRenderer(_ref2) {
  var layout = _ref2.layout, fields = _ref2.fields, form = _ref2.form, intl = _ref2.intl, _ref2$initialValues = _ref2.initialValues, initialValues = _ref2$initialValues === void 0 ? {} : _ref2$initialValues, customData = _ref2.customData;
  return fields.map(_renderItem({
    form,
    intl,
    initialValues,
    layout,
    customData
  }));
}
__name(FormItemsRenderer, "FormItemsRenderer");
export {
  FormItemsRenderer
};
